import { jsx as _jsx } from "react/jsx-runtime";
import { isValidElement } from 'react';
import { styled } from '../../utils';
export function FormFlexItem({ children, ...props }) {
    if (isValidElement(children) && children.type === FormFlexItem) {
        return children;
    }
    return (_jsx(FormFlexItemRoot, { ...props, className: props.className, children: children }));
}
const FormFlexItemRoot = styled('div', {
    shouldForwardProp: (prop) => prop !== 'height' &&
        prop !== 'width' &&
        prop !== 'rowGap' &&
        prop !== 'columnGap' &&
        prop !== 'minWidth' &&
        prop !== 'flexGrow' &&
        prop !== 'flexShrink' &&
        prop !== 'flexBasis',
    name: 'FormFlexItem',
})(({ theme, width, height, 
//rowGap,
columnGap, minWidth, flexGrow, flexShrink, flexBasis, }) => ({
    minWidth: minWidth ?? '',
    height: height ?? '',
    width: width === 'auto' || !columnGap
        ? width
        : `calc(${width} - ${theme.spacing(columnGap)})`,
    // ...(theme.supports.flexGap
    //   ? {}
    //   : {
    //       padding: theme.spacing((columnGap || 0) / 2, (rowGap || 0) / 2), // TODO: pass through to the children with custom class
    //     }),
    flexGrow: !flexGrow ? flexGrow : 1,
    flexShrink: !flexShrink ? flexShrink : 1,
    ...(flexBasis !== undefined
        ? { flexBasis: flexBasis === 100 ? '100%' : 0 }
        : {}),
}));
